<!-- 水泵站详情 -->
<template>
  <div class="dialog-pump">
    <div class="header">
      <div class="title">{{ data.name || '-' }}</div>
    </div>
    <div class="body">
      <div class="content">
        <div class="descriptions-group">
          <div class="descriptions-item">
            <span class="key">用途:</span>
            <span class="value">{{ data.purpose || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">规模（万吨/年）:</span>
            <span class="value">{{ data.scale || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">年取水量:</span>
            <span class="value">{{ data.yearQsl || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">保护范围:</span>
            <span class="value">{{ data.protectArea || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">所处生态敏感区:</span>
            <span class="value">{{ data.ecologyArea || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">占用岸线长度（KM）:</span>
            <span class="value">{{ data.zyaxcd || '-' }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { toRefs, nextTick, getCurrentInstance, onMounted } from 'vue'
import { ref } from 'vue-demi'
const props = defineProps({
  data: Object,
})
const { data } = toRefs(props)
</script>

<style lang="scss" scoped>
.dialog-pump {
  width: 54.35rem;
  min-width: 54.35rem;
  .header {
    text-align: left;
    margin-bottom: 15px;
    border-bottom: 1px solid #ddd;
    .title {
      font-family: Microsoft YaHei;
      font-style: normal;
      font-weight: bold;
      height: 32px;
      font-size: 16px;
    }
  }
  .body {
    .content {
      margin-bottom: 2rem;
      .descriptions-group {
        overflow: hidden;
        h5 {
          font-size: 14px;
          margin: 10px 0;
        }
        .descriptions-item {
          width: 50%;
          float: left;
          line-height: 2.65rem;
          margin-bottom: 1rem;
          &:last-of-type {
            margin-bottom: 1.4rem;
          }
          .key {
            display: inline-block;
            color: #ffffff;
            width: 13.8rem;
            margin-right: 1.9rem;
            text-align: left;
          }
        }
      }
    }
  }
}
</style>
